import { gql } from 'graphql-request'

export const addClientPrivateNote = gql`
  mutation AddClientPrivateNote(
    $clientId: String!
    $siteId: String!
    $text: String!
    $date: DateTime!
  ) {
    addClientPrivateNote(clientId: $clientId, siteId: $siteId, text: $text, date: $date) {
      id
    }
  }
`
export const createTanningCheckIn = gql`
  mutation CreateTanningCheckIn($clientId: ID!, $siteId: ID!, $source: CheckInSource!) {
    createTanningCheckIn(clientId: $clientId, siteId: $siteId, source: $source) {
      checkInId
      clientId
      siteId
      type
      status
      source
      dateTime
      client {
        id
        firstName
        lastName
        dateOfBirth
        homeSiteId
        homeSiteName
        notes
        profileImage(input: { format: webp, type: thumbnail }) {
          url
        }
        totalCheckInCount
        siteInformation {
          siteId
          lastCheckInOn
          checkInCount
        }
      }
    }
  }
`

export const createCheckIn = gql`
  mutation CreateCheckIn($siteId: ID!, $clientId: ID!, $source: CheckInSource!) {
    createCheckIn(siteId: $siteId, clientId: $clientId, source: $source) {
      checkInId
      clientId
      siteId
      type
      status
      source
      dateTime
      failReason
      createdAt
      failedInvoices {
        invoiceId
        amount
      }
      stagedInvoices {
        invoiceId
        amount
        dueDate
        description
      }
      nextSession {
        sessionId
        sessionName
        sessionDateTime
      }
      client {
        id
        firstName
        lastName
        dateOfBirth
        homeSiteId
        homeSiteName
        notes
        profileImage(input: { format: webp, type: thumbnail }) {
          url
        }
        totalCheckInCount
        siteInformation {
          siteId
          lastCheckInOn
          checkInCount
        }
      }
      service {
        serviceId
        serviceName
        serviceType
        creditsRemaining
      }
      site {
        siteId
        name
      }
    }
  }
`
